module.exports = __webpack_public_path__ + "static/img/adret.9726e25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/adret.png
// module id = e9we
// module chunks = 1